module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الساعة_الرابعة-أمبر"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("#الساعة_الرابعة #أمبر")])]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "2.78125in",
      "height": "0.33647in"
    },
    attrs: {
      "alt": " ",
      "src": "media/file1.png"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أغمضتُ عينيَّ بقسوةٍ حين باغتَتني إضاءةٌ متتاليةٌ مِن السيَّارة الألمانيَّة السوداء أمامي فورَ خروجي مِن البوَّابة الرئيسة عند انتهاء الدَّوام المدرسي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حبًّا بالله بيرون، الجميع في هذه المدرسة البغيضة، لا بل في سيدني كلِّها يعلم أنَّ هذه السيَّارة أحادية الرَّقم وشبه المصفَّحة هي التي تقلُّني بها ذهابًا وإيابًا كلَّ يوم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تقدَّمتُ أفتح باب السيارة الخلفي لأُلقِي حقيبتي، وآخذَ مقعدي في الأمام بجوار السَّائق ذي الوجه الذي يشبه الجرو، والشَّعر الأشقر الطويل المجعَّد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('strong', [_vm._v("- يااااه! اشتقتُ إليكَ يا رجل، كيفَ حالُك؟ وكيف يُبلِي العمُّ جيراد؟ واه! دعني أرى، يبدو أنَّكَ كسبتَ بعضَ الوزنِ.. صحيح")]), _vm._v("؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أظنُّني أمطرتُه بالأسئلة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("علَت ضحكةُ بيرون لتتَّسع ابتسامتي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعثرَ شعري القصير في مرحٍ بيده اليُمنى، في حين كانَت يدُه اليسرى تمسكُ بالمقودِ في مهارةٍ متجاوزةً الطريق الفرعيَّ للمدرسة بسلاسة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ارتخى جسدي على المقعد الجلدي الوثير لأغمض عيني، وأتنهَّد بخيبةٍ، هو يعلمُ جيِّدًا أنَّني أفتقدُ ذلك الطويل المتَوطوِط.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هل كانَ اليوم الأوَّل في المدرسة ممتعًا؟")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- طالبٌ جديدٌ حاول كسبَ صداقتي بطريقةٍ دراميَّة.")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("-أوه!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تكوَّرَت شفتاهُ بشكلٍ ظريفٍ لأضحك، هذا البيرون يجيدُ تشتيت أفكاري حقًّا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- "), _c('strong', [_vm._v("وهل نجحَ في ذلك؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سألَ لأجيبه وسطَ قهقهاتي:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أظنُّه فعلَ.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تبدَّدَت ضحكتي عندَما وقعَت عيني على ربطةِ عنقٍ سوداءَ بقرب المسند، إنَّها حتمًا تعود إلى لوي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بيرون بصوتٍ هادئٍ حنون:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لقد ذهبنا اليوم أنا ولوي وكاي لتفقُّد مشروع المستشفى الخاصِّ بوالدتكِ الرَّاحلة.")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لِمَ لَم يأتِ معك؟ ألا يزال يعمل هناك؟")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هو فقط أمرَني بالتوجُّهِ إلى الشركة مجدَّدًا، استقلَّ سيارتَه، ولا أعلم إلى أين ذهبَ.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تنهَّدتُ ونقلتُ نظري إلى السماءِ بعدما أنزلتُ زجاج نافذة الباب.. يا إلهي! السماءُ هذا اليوم ملبَّدة بالغيوم كقطع مارشملو متراصَّة تتخلَّلُها خيوطُ أشعَّةِ الشَّمس الذهبيَّة المائلة إلى الاحمرار، صورة ترتاح لها الأعين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الواقع، أحببتُ الهواءَ البارد الذي جعلَ جدران قصبتي الهوائيَّة تنتعش بشعور لطيف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أغمضتُ عينيَّ عندما تسلَّلَت موسيقى قيثارة هادئة مسمعي؛ لآخُذَ نفَسًا عميقًا مرَّةً أخرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فورَ وصولنا إلى المنزل أشارَ بيرون نحو الجزءِ المظلَّل داخل أسوار الحديقةِ إلى سيارة لوي المرسيدس جي 65.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تشبَّثتُ بعنقه في سعادة، وأشرقَتِ الدُّنيا في عينيَّ وكأنَّ الغيومَ في الأعلى قد تبدَّدَت.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هيه! أنتِ، أتريدين مِن لوي أن يقتلني؟ أمبر ابتعِدي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دراميَّة، أعلمُ، ولكن لا يهمُّ، بسببِ مشروع المستشفى ذاك والأعمال الأخرى الكثيرة التي يتكفَّلُ بها لوي، أكاد لا أراه إلَّا قليلًا، وقليلًا جدًّا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أسرعْتُ بخطواتي أعبر الحديقة الباهتة الواسعة، هي باهتةٌ لأنَّ صاحب المنزل يسمحُ بزراعة النباتات والزُّهور البيضاء فقط، لماذا؟ أخبرتُكم لأنَّه مُتوَطوِط!")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- جيجي، لقد عدتُ.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما إن فتحَت الباب وأجهرت بها حتَّى وصلَ إلى مسمعي صوتُ كعبٍ عالٍ يضرب الأرض لتظهرَ بعدَها جيجي مدبِّرة منزلنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسنًا هي تبدو يافعةً بالرَّغم مِن أعوام عمرها التي تتجاوزُ الأربعين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ترتدي فستانًا أسوَد اللَّون قصيرًا نوعًا ما، ضيِّقًا يُبرزُ تقاسيم جسدها المثير الذي تخفيه بمِئزر طبخٍ أبيض اللَّون.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رميتُ بحقيبتي أرضًا لأحتضنَها.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أوه صغيرتي! جائعة!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أومأتُ بإيجابٍ وقد كنتُ ما زلتُ أحتضنها.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لقد صنعتُ كعكة الشوكولاتة البيضاء، أسرِعي واغتسِلي ريثما أجهِّز القهوة للسيِّد لوي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رفعتُ رأسي نحوَها:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أريدُ مخفوق الفانيلا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قهقهَت جيجي في مرحٍ، في حين أسرعتُ أنا بالصعود نحو غرفتي، جمعْتُ راحتَي يدي لتمتلئ بالماء البارد المثلَّج لأصعقَ به نسيج وجهي بانتعاش.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تخلَّصتُ مِن ملابس المدرسة لأستبدلَ بها شورت جينز قصير وهودي أبيض أُخفِي به لون البنطال الأزرق بطوله.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خرجتُ أدندنُ متوجِّهة نحو ثاني أكبر غرفِ المنزل وأوسعها على الإطلاق، مكتبة لوي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هو كالمعتاد يجلس على ذلك المكتب أمام الحاسوب الذي انعكسَت إضاءته عليه لتزيد منظره هيبةً.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("علمتُ أنَّه شعرَ بوجودي حين أغلقَ الحاسوب، ورفع رأسَه نحوي مبتسمًا،")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استقام لأهرع نحوه")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اشتقتُ لرائحتكَ أميرتي!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالها وهو يفركُ بأرنبة أنفه بين خصلات شعري، مثَّلتُ الانزعاجَ، وأملتُ بشفتَيَّ مبتعِدة:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- حقًّا! لِمَ لَم تأتِ عِوَضًا عن بيرون لترجعَني مِن المدرسة إذن؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشار إلى علبةٍ سوداء على طاولة مكتبه لأتَّجه نحوها، وأخذ مكانه على الأريكة السوداء، وصار يراقبني مبتسمًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كراتٌ مِن الهواء تجمَّعَت بحنجرتي أكتم بها شعوري الصاخب ورغبتي بالصراخ.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يا إلهي")]), _vm._v(" Superstar Holographic shoes")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لقد حاولتُ الحصولَ عليها جاهدةً ولَم أُفلِح، أنت مذهلٌ لوي!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعقبتُ حديثي أن قفزتُ بطفوليَّة، ويبدو أنَّ ذلك كان مضحكًا بنظر لوي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ربَّت براحته على الأريكة الجلدية لأجلس بجواره.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ارتديها لتأخذكِ إلى الكثير مِن الأماكن الجميلة أميرتي، فمرحلةُ الدِّراسة تحوي أيَّامًا ستوَدِّين الرُّجوع إليها حتمًا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بالرَّغم مِن أنَّني لا أتَّفق معه أبدًا، إلَّا إنَّني التزمتُ الصمتَ، وأعدتُ نظري أكحله بجمال حذائي ذي الخطوط البرَّاقة.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ادخلي جيجي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فُتِحَ الباب لتلمع عدسَتَا عيني حين نظرتُ إلى الكعكةِ المغطَّاةِ بطبقةِ الكريمة البيضاء، ثم التفَتُّ إلى لوي ذي العيون الباهتة الناعسة:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ألَم تنَم جيِّدًا؟ تبدو كالباندا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سخرتُ ليتنهَّد مشيرًا إلى قدح القهوة أمامه.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أشعرُ بالصداع، أيمكنُكِ مناولتي القهوة؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قلبتُ عيني وأنا أناوله قهوته، لأجلس بعدَها بجواره مجدَّدًا وأنا أرفع يدي لأضعها خلف رقبتهِ، بحيث أستطيعُ العبثَ بأطراف خصلاته المتفحِّمة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("همستُ"), _c('strong', [_vm._v(": ")])])]), _vm._v(" "), _c('ul', {
    staticClass: "line"
  }, [_c('li', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما بكَ؟")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أجابَ بتململٍ لأحرِّكَ أصابعي بخفَّة:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا شيء، فقط بعض الأعمال المتراكمة.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سألتُ بهمسٍ منخفضٍ: أ"), _c('strong', [_vm._v("تريدُ مساج؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أومئ مِن دون أن يفتح عينيه، فاستنشقتُ ماء أنفي لأنهضَ وأقف خلف مسند ظهر الأريكة، رفعتُ يدي لأُمركزهما على جانب رأسه، وأبدأ بتمسيده بضغطٍ خفيف، بعثرتُ شعرَه جاعلةً خصلاته النَّاعمة تتداخل بين أصابعي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تذمَّرتُ حين لمحتُ تقطيبة حاجبَيه السميكين:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- "), _c('strong', [_vm._v("فُكَّ عقدةَ حاجبيكَ!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فكَّهما بسرعة، وارتخَت معالم وجهه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الحقيقة راق لي ملمسُ خيوط شعره لأبتسم في خبثٍ، وأجمع شَعره إلى منتصف رأسه، ثمَّ أسحبه إلى أعلى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم أستطِع إمساك نفسي لتهربَ ضحكةٌ مرحة مِن شفتيَّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هو فتح عينيه لينظر إليَّ باستغرابٍ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أصبحَ لديكَ عرف ديكٍ!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سخرتُ بين قهقهاتي ليتأفَّف:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أعيديه إلى طبيعته أيَّتُها الدَّجاجة!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتعدتُ مسافة الأمان منه وأنا أجيبه ساخرةً:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن أفعل، تبدو وسيمًا هكذا!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لكم أن تتخيَّلوا لوي الأنيق المثير والمثالي يتحوَّل إلى طفلٍ كبيرٍ يحاول أن يمسكَ بي وسط أجواءٍ مليئةٍ بالضَّحكات والتهديدات الساخرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هكذا هي الأوقات الذَّهبيَّة التي أقضيها معه، نعَم يدعونه الوصيَّ عليَّ قانونيًّا، ولا أمانع هذا أبدًا، ألا يكفي أنَّه وسيم كاللَّعنة؟!"), _c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4788824c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch010.vue
// module id = 93
// module chunks = 0